import React, { useEffect } from "react";
import Logo from "../navigation/img/logo.png";
import { FaFacebook } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaXTwitter } from "react-icons/fa6";
import { CiInstagram } from "react-icons/ci";
import { useSelector, useDispatch } from "react-redux";
import { fetchFooter } from "../store/action/contentAction";
import { Link } from "react-router-dom";
import "../home/home.css";

function Footer({ toggleLogin }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFooter());
  }, [dispatch]);

  const footerData = useSelector((state) => state.footer.data) || [];

  return (
    <footer className="section-pl footer">
      <>
        {footerData.map((item) => (
          <>
            <div className="col">
              <img className="logo" src={Logo} alt="" />
              <h4>Contact</h4>
              <p>
                <strong>Address: </strong>
                {item.address}{" "}
              </p>
              <p>
                <strong>Address: </strong>
                {item.address_1}{" "}
              </p>
              <p>
                <strong>Address: </strong>
                {item.address_2}{" "}
              </p>
              <p>
                <strong>Phone: </strong>
                {item.phone}{" "}
              </p>
              <p>
                <strong>Hours: </strong>
                {item.open} - {item.close}, Mon - Sat{" "}
              </p>
            </div>
            <div className="col">
              <h4>About</h4>
              <Link to="/About"> About Us</Link>
              {isAuthenticated && (
                <Link to="/CheckOut"> Delivery Information</Link>
              )}
              <Link to="/Contact"> Contact Us</Link>
            </div>
            <div className="col">
              <h4>My Account</h4>
              <Link onClick={toggleLogin}> Sign In</Link>

              <Link to="/OrdersTable"> Track My Order</Link>
              <Link to="/Contact"> Help</Link>
            </div>
            <div class="col">
              <div className="follow">
                <h4>Follow Us</h4>
                <div className="icon">
                  <a
                    className="icons"
                    href="https://web.facebook.com/citygamersandelectronics"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook />
                  </a>
                  <a className="icons" href="mailto:citygamersword@gmail.com">
                    <MdEmail />
                  </a>
                  <a
                    className="icons"
                    href="https://x.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaXTwitter />
                  </a>
                  <a
                    className="icons"
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CiInstagram />
                  </a>
                </div>
              </div>
            </div>
            <div className="copyright">
              <p>{item.copyright} | Cactus Labs © 2025</p>
            </div>
          </>
        ))}
      </>
    </footer>
  );
}

export default Footer;
